<template>
  <HKLTabs
    :defaultActiveKey="1"
    class="guideline-tabs-outer"
  >
    <a-tab-pane
      :key="1"
      :tab="$t(`settings.regionConfig.env`)"
    >
      <EnvPage />
    </a-tab-pane>

    <a-tab-pane
      :key="2"
      :tab="$t(`settings.regionConfig.terms`)"
    >
      <TncIndex />
    </a-tab-pane>
    <a-tab-pane
      :key="3"
      :tab="$t(`settings.regionConfig.images`)"
    >
      <RegionImage />
    </a-tab-pane>
  </HKLTabs>
</template>

<script>
import HKLTabs from '@/controls/Tab/HKLTabs'
import EnvPage from './regionConfig/EnvPage'
import RegionImage from './regionConfig/RegionImage'
import TncIndex from './regionConfig/TncIndex.vue'

export default {
  components: {
    HKLTabs,
    EnvPage,
    RegionImage,
    TncIndex,
  },
  setup () {
  },
}
</script>

<style lang="scss" scoped>
.guideline-tabs-outer {
  padding: 0 24px
}

</style>
